export default "__VITE_ASSET__D6hpoi2r__"